/* Lavori svolti (portfolio) data for Studio Cecconato.

   Each "category" maps to one .rar file from the client's archive.
   Each category contains one or more "projects" with multiple images.
*/

export const lavori = [
  {
    slug: "progettazione",
    title: "Progettazione",
    category: "Progettazione",
    short:
      "Progetti residenziali e di lottizzazione: nuove costruzioni, ristrutturazioni e piani urbanistici nel territorio trevigiano.",
    cover: "/images/lavori/progettazione/tubia-benetton-1-1.jpg",
    projects: [
      {
        name: "Tubia–Benetton",
        location: "Provincia di Treviso",
        published_at: "2025-04-08",
        description:
          "Progettazione edile residenziale con redazione delle tavole di piante e prospetti.",
        images: [
          { src: "/images/lavori/progettazione/tubia-benetton-1-1.jpg", caption: "Piante" },
          { src: "/images/lavori/progettazione/tubia-benetton-2-1.jpg", caption: "Prospetti" },
        ],
      },
      {
        name: "Gagno – Lottizzazione Visnadello",
        location: "Visnadello (TV)",
        published_at: "2026-02-14",
        description:
          "Piano di lottizzazione con elaborati urbanistici e tavole tecniche per opere di urbanizzazione.",
        images: [
          { src: "/images/lavori/progettazione/gagno-lottizzazione-visnadello-1-1.jpg", caption: "Tavola 01" },
          { src: "/images/lavori/progettazione/gagno-lottizzazione-visnadello-2-1.jpg", caption: "Tavola 02" },
          { src: "/images/lavori/progettazione/gagno-lottizzazione-visnadello-3-1.jpg", caption: "Tavola 03" },
          { src: "/images/lavori/progettazione/gagno-lottizzazione-visnadello-4-1.jpg", caption: "Tavola 04" },
        ],
      },
      {
        name: "Gagno – Via Morganella",
        location: "Villorba (TV)",
        published_at: "2025-02-20",
        description:
          "Progetto residenziale: piante piano terra/primo, sezioni e prospetti.",
        images: [
          { src: "/images/lavori/progettazione/gagno-via-morganella-1-1.jpg", caption: "Piano terra e primo" },
          { src: "/images/lavori/progettazione/gagno-via-morganella-2-1.jpg", caption: "Sezioni e prospetti" },
        ],
      },
      {
        name: "Gagno – Villa Ruberti",
        location: "Provincia di Treviso",
        published_at: "2024-12-15",
        description:
          "Sistemazione esterna, piante e prospetti per intervento su villa.",
        images: [
          { src: "/images/lavori/progettazione/gagno-villa-ruberti-1-1.jpg", caption: "Sistemazione esterna" },
          { src: "/images/lavori/progettazione/gagno-villa-ruberti-2-1.jpg", caption: "Piante" },
          { src: "/images/lavori/progettazione/gagno-villa-ruberti-3-1.jpg", caption: "Prospetti e sezioni" },
        ],
      },
    ],
  },
  {
    slug: "fotogrammetria-terrestre",
    title: "Topografia · Fotogrammetria terrestre",
    category: "Topografia",
    short:
      "Rilievi fotogrammetrici terrestri di edifici storici per la generazione di nuvole di punti e ortofoto.",
    cover: "/images/lavori/fotogrammetria-terrestre/Villa S. facciata Sud_ortofoto.jpg",
    projects: [
      {
        name: "Villa S. – Facciata Sud",
        location: "Provincia di Treviso",
        published_at: "2026-03-22",
        description:
          "Rilievo fotogrammetrico terrestre della facciata sud con generazione di nuvola di punti e ortofoto ad alta risoluzione.",
        images: [
          { src: "/images/lavori/fotogrammetria-terrestre/Villa S. facciata Sud_nuvola punti.jpg", caption: "Nuvola di punti" },
          { src: "/images/lavori/fotogrammetria-terrestre/Villa S. facciata Sud_ortofoto.jpg", caption: "Ortofoto" },
        ],
      },
    ],
  },
  {
    slug: "rilievi-drone-fotogrammetria",
    title: "Topografia · Rilievi Drone – Fotogrammetria",
    category: "Topografia",
    short:
      "Rilievi fotogrammetrici aerei con drone: ortofoto georeferenziate, nuvole di punti e mesh 3D.",
    cover: "/images/lavori/rilievi-drone-fotogrammetria/Tenuta delle Mele_Mesh 3D.jpg",
    projects: [
      {
        name: "Tenuta delle Mele",
        location: "Veneto",
        published_at: "2025-11-30",
        description: "Rilievo aereo con drone e generazione di mesh 3D dell'area.",
        images: [
          { src: "/images/lavori/rilievi-drone-fotogrammetria/Tenuta delle Mele_Mesh 3D.jpg", caption: "Mesh 3D" },
        ],
      },
      {
        name: "Piazza",
        location: "Veneto",
        published_at: "2025-10-05",
        description: "Rilievo fotogrammetrico aereo di piazza urbana con restituzione di nuvola di punti e ortofoto.",
        images: [
          { src: "/images/lavori/rilievi-drone-fotogrammetria/Piazza_nuvola di punti.jpg", caption: "Nuvola di punti" },
          { src: "/images/lavori/rilievi-drone-fotogrammetria/Piazza_ortofoto.jpg", caption: "Ortofoto" },
        ],
      },
    ],
  },
  {
    slug: "rilievi-drone-lidar",
    title: "Topografia · Rilievi Drone – LIDAR",
    category: "Topografia",
    short:
      "Rilievi LIDAR aerotrasportati con drone DJI Matrice 350 RTK + Zenmuse L2 per territorio e patrimonio costruito.",
    cover: "/images/lavori/rilievi-drone-lidar/Val Lapisina_nuvola di punti con vegetazione.jpg",
    projects: [
      {
        name: "Val Lapisina",
        location: "Treviso",
        published_at: "2026-09-15",
        description:
          "Rilievo LIDAR di porzione di Val Lapisina con generazione di nuvole di punti complete e filtrate del solo terreno, sovrapposte a basemap Google Maps.",
        images: [
          { src: "/images/lavori/rilievi-drone-lidar/Val Lapisina_nuvola di punti con vegetazione.jpg", caption: "Nuvola con vegetazione" },
          { src: "/images/lavori/rilievi-drone-lidar/Val Lapisina_nuvola di punti terreno.jpg", caption: "Nuvola del solo terreno" },
          { src: "/images/lavori/rilievi-drone-lidar/Val Lapisina_ortofoto su google maps.jpg", caption: "Ortofoto su Google Maps" },
        ],
      },
      {
        name: "Abitazione",
        location: "Veneto",
        published_at: "2025-08-18",
        description: "Rilievo LIDAR di abitazione con generazione di nuvola di punti e mesh 3D.",
        images: [
          { src: "/images/lavori/rilievi-drone-lidar/Abitazione_nuvola di punti.jpg", caption: "Nuvola di punti" },
          { src: "/images/lavori/rilievi-drone-lidar/Abitazione_Mesh 3D.jpg", caption: "Mesh 3D" },
        ],
      },
      {
        name: "Cava L.P.",
        location: "Veneto",
        published_at: "2026-07-20",
        description: "Rilievo LIDAR di cava con calcolo volumi e restituzione di ortofoto.",
        images: [
          { src: "/images/lavori/rilievi-drone-lidar/Cava L.P._nuvola di punti.jpg", caption: "Nuvola di punti" },
          { src: "/images/lavori/rilievi-drone-lidar/Cava L.P._ortofoto.jpg", caption: "Ortofoto" },
        ],
      },
    ],
  },
  {
    slug: "rilievi-laserscanner",
    title: "Topografia · Rilievi Laserscanner",
    category: "Topografia",
    short:
      "Rilievi 3D ad alta densità con laser scanner statico Riegl VZ-400i: infrastrutture, edifici e siti complessi.",
    cover: "/images/lavori/rilievi-laserscanner/Rilievo Viadotto SR 348.jpg",
    projects: [
      {
        name: "Rilievo rotatoria SS13 – Spresiano",
        location: "Spresiano (TV)",
        published_at: "2024-10-30",
        description: "Rilievo laserscanner di rotatoria stradale sulla SS13.",
        images: [
          { src: "/images/lavori/rilievi-laserscanner/Rilievo rotatoria SS13 Spresiano.jpg", caption: "Nuvola di punti rotatoria" },
        ],
      },
      {
        name: "Rilievo Viadotto SR 348",
        location: "Veneto",
        published_at: "2026-05-10",
        description: "Rilievo laserscanner di viadotto stradale lungo la SR 348.",
        images: [
          { src: "/images/lavori/rilievi-laserscanner/Rilievo Viadotto SR 348.jpg", caption: "Nuvola di punti viadotto" },
        ],
      },
      {
        name: "Rilievo CCIA Treviso",
        location: "Treviso",
        published_at: "2025-06-12",
        description: "Rilievo laserscanner di edifici della Camera di Commercio di Treviso.",
        images: [
          { src: "/images/lavori/rilievi-laserscanner/Rilievo CCIA Treviso.jpg", caption: "Nuvola di punti edificio CCIA" },
        ],
      },
    ],
  },
];

/**
 * Flat list of all projects with category info, sorted by published_at desc.
 * Projects without published_at are placed at the end.
 */
export const latestProjects = lavori
  .flatMap((cat) =>
    cat.projects.map((p) => ({
      ...p,
      categorySlug: cat.slug,
      categoryTitle: cat.title,
      categoryShortTitle: cat.category,
      cover: p.images?.[0]?.src,
      coverCaption: p.images?.[0]?.caption,
    }))
  )
  .sort((a, b) => {
    if (!a.published_at && !b.published_at) return 0;
    if (!a.published_at) return 1;
    if (!b.published_at) return -1;
    return b.published_at.localeCompare(a.published_at);
  });

export function formatPublishedAt(iso) {
  if (!iso) return "";
  const months = [
    "gen", "feb", "mar", "apr", "mag", "giu",
    "lug", "ago", "set", "ott", "nov", "dic",
  ];
  const [y, m, d] = iso.split("-").map(Number);
  if (!y || !m || !d) return iso;
  return `${d} ${months[m - 1]} ${y}`;
}
